import register from '@kpsys/angularjs-register';
import AutoFillSyncDirective from './kp-auto-fill-sync.directive';

/**
 * @ngdoc module
 * @name portaro.shared.directives
 * @module portaro.shared.directives
 */
export default register('portaro.shared.directives')
    .directive(AutoFillSyncDirective.directiveName, AutoFillSyncDirective)
    .name();